<template>
  <div id="app">
     <login-view v-if="isAuth"></login-view>
     <main-view v-else></main-view>
  </div>
</template>

<script>
import '@/assets/styles/main.css'
import MainView from '@/components/MainView'
import LoginView from '@/components/LoginView'

export default {
  name: 'App',
  components: {
    MainView,
    LoginView
  },
  computed: {
    isAuth () {
      let isAuth = false
      const authFree = ['/login', '/loginEx', '/privacy', '/tac']

      for (let path of authFree) {
        if (this.$route.path.match(path)) return true
      }
      return isAuth
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue